module.exports = __webpack_public_path__ + "img/addresses.14558de5.png";